<template>
  <div class="c-input-password">
    <input
      class="c-input-password__input"
      :class="{ hasError }"
      :autocomplete="autocomplete"
      :name="name"
      :type="type"
      :value="value"
      @input="$emit('input', $event)"
    />
    <button
      @click="showPassword = !showPassword"
      type="button"
      class="c-input-password__button"
      tabindex="-1"
    >
      <i :class="iconClass"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ComponentInputPassword',
  props: {
    autocomplete: { type: String, default: '' },
    hasError: { type: Boolean, default: false },
    name: { type: String, default: '' },
    value: { type: String, default: '' },
  },
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    type() {
      return this.showPassword ? 'text' : 'password'
    },
    iconClass() {
      return this.showPassword ? 'icon-eye-open' : 'icon-eye-close'
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/modules/form-new';
@use '~/scss/generic/variables';

.c-input-password {
  position: relative;

  &__input {
    @extend .m-form__input;

    &.hasError {
      border-color: variables.$color-red;
    }
  }

  &__button {
    bottom: 0;
    color: variables.$color-text-gray;
    font-size: 24px;
    padding: 5px;
    position: absolute;
    right: 5px;
    top: 0;
  }
}
</style>
